import { Controller } from 'stimulus'

import './order_component.scss'

export default class extends Controller {
  static classes = ['rotated', 'caretSelected', 'caretNotSelected']
  static targets = ['orderCaret', 'form', 'orderBy', 'item']

  connect (): void {
    const params = new URLSearchParams(window.location.search)
    const orderBy = params.get('dynamic_attributes[order]')
    const itemId = params.get('dynamic_attributes[order_by_item_id]')

    if (this.hasOrderByAndItemId(orderBy, itemId)) {
      this.orderByTarget.value = orderBy
      this.orderCaretTarget.classList.toggle(this.caretSelectedClass)

      if (['asc', 'ASC'].includes(orderBy)) {
        this.toggle()
      }
    } else {
      this.orderCaretTarget.classList.toggle(this.caretNotSelectedClass)
    }
  }

  toggle = (): void => {
    if (this.hasOrderCaretTarget !== null) {
      this.orderCaretTarget.classList.toggle(this.rotatedClass)
    }
  }

  submitForm = (event): void => {
    event.preventDefault()

    const { value } = this.orderByTarget
    this.orderByTarget.value = ['DESC', 'desc'].includes(value) ? 'ASC' : 'DESC'
    this.appendQueryParamsToForm()
    this.formTarget.submit()
  }

  hasOrderByAndItemId = (orderBy: string, itemId: string): boolean => {
    return (orderBy !== null && this.itemTarget.value === itemId)
  }

  appendQueryParamsToForm = (): void => {
    const urlParams = new URLSearchParams(window.location.search)

    urlParams.forEach((value, key) => {
      this.appendInputToForm(key, value)
    })
    this.appendInputToForm('dynamic_attributes[order_by_item_id]', this.itemTarget.value)
    this.appendInputToForm('dynamic_attributes[order]', this.orderByTarget.value)
  }

  appendInputToForm = (name: string, value: string): void => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = name
    input.value = value
    this.formTarget.appendChild(input)
  }
}
